const interval = setInterval(() => {
  const select = document.querySelector('#select-group-682a60ad30501');

  if (select) {
    const placeholderOption = document.createElement('option');
    placeholderOption.text = 'HOW DID YOU HEAR ABOUT US?';
    placeholderOption.disabled = true;
    placeholderOption.selected = true;

    select.insertBefore(placeholderOption, select.firstChild);

    clearInterval(interval); 
  }
}, 200);

setTimeout(() => {
  clearInterval(interval);
}, 5000);
